export { default } from './ClinicalNoteDownload';
